module.exports = {

    prefix: '',
    important: true, //until we get rid of codylab

    content: [
        './src/**/*.{html,ts}',
    ],
    safelist: [
          {

    pattern: /^((sm|md|lg|xl|2xl):)?w-(\d+|full|screen|min|max|auto|(1|2|3|4|5|6|7|8|9|10|11)\/(2|3|4|5|6|12))$/,

  },
  
        'sm:flex',
        'md:flex',
        'bg-black',
        'sm:p-0',
        'p-0',
        'max-w-7xl',
        'max-w-[1320px]',
    ],

    darkMode: 'class', // or 'media' or 'class'
    theme: {
        extend: {
            screens: {
                'xs': '360px',
                'sm': '640px',     // original Tailwind
                'md': '768px',     // original Tailwind
                'lg': '1024px',    // original Tailwind
                'xl': '1280px',    // original Tailwind
                '2xl': '1536px',   // original Tailwind

                'xxl': '1695px',
                 'xxxl': '1910px',

                 '3xl': '1920px',
                 '4xl': '2560px',
                // Personalizados adicionales
                'mobile-xs': '360px',
                'mobile-md': '393px',
                'mobile-lg': '430px',
                'phablet': '600px',
                'laptop': '1280px',
                '4k': '1920px',
                'landscape': { raw: '(orientation: landscape)' },
                'short': { raw: '(max-height: 600px)' },
            },

            /* screens: {
                 // adding xs to the rest
                 'sm': '640px',
                 'md': '768px',
                 'lg': '1024px',
                 'xl': '1280px',
                 '2xl': '1536px',
                 'xs': '320px',
                 'xxl': '1695px',
                 'xxxl': '1910px',
                 '3xl': '1920px',
                 '4xl': '2560px',
                 //
                  'mobile-sm': '396px',  // iPhone 14
       'mobile-md': '480px',  // Dispositivo más grande
       'tablet': '768px',
       'desktop': '1024px',
             }, */

            boxShadow: ['hover'], // Habilita hover para shadows

            fontSize: {
                '2xs': '0.625rem', // 10px (nuevo tamaño)
            },
            keyframes: {
                'wave-glow': {
                    '0%, 100%': { filter: 'drop-shadow(0 0 10px rgba(255,255,255,0.6))' },
                    '50%': { filter: 'drop-shadow(0 0 25px rgba(255,255,255,0.9))' },
                },
            },
            animation: {
                'wave-glow': 'wave-glow 6s ease-in-out infinite',
            },
            width: {
                
                '76': '76%',
                '90': '90%',
                '70p': '70%',
            },
            maxWidth: {
                '60': '60%',
                '90': '90%',
                '8xl': '88rem',
                '1240': '1240px',
                '1570': '1570px',
                 '1320': '1320px',
            },
            height: {
                '8': '2rem',
                '10': '2.5rem',
                '12': '3rem',
                '14': '3.5rem',
                '16': '4rem',
                '28': '7rem',
                '48': '12rem',
                '136px': '136px',
                '19': '19rem',
                '144': '36rem',
                '4-5': '4.5rem',
                '3-5': '3.5rem',
                '2-5': '2.5rem',
                '0-4': '0.4rem',
                '280px': ' 280px',

            },
            maxHeight: {
                '4em': '4em',
            },
            minHeight: {
                '52': '13rem',
            },
            spacing: {
                '70px': '70px',
                '12': '3rem',
                '24': '6rem',
                '20': '5rem',
            },
            colors: {
                black: {
                    DEFAULT: '#000000', // valor para bg-black
                    100: '#D3D5E4',
                    200: '#B2B5CD',
                    300: '#8C91B4',
                    400: '#7D83AA',
                    500: '#F59833',
                    600: '#535A8B',
                    700: '#414776',
                    800: '#282D58',
                    900: '#020D38'
                },

                primary: {
                    100: 'var(--v2-color-primary-100)',
                    200: 'var(--v2-color-primary-200)',
                    300: 'var(--v2-color-primary-300)',
                    400: 'var(--v2-color-primary-400)',
                    500: 'var(--v2-color-primary-500)',
                    600: 'var(--v2-color-primary-600)',
                    700: 'var(--v2-color-primary-700)',
                    800: 'var(--v2-color-primary-800)',
                    900: 'var(--v2-color-primary-900)'
                },
                secondary: {
                    100: 'var(--v2-color-secondary-100)',
                    200: 'var(--v2-color-secondary-200)',
                    300: 'var(--v2-color-secondary-300)',
                    400: 'var(--v2-color-secondary-400)',
                    500: 'var(--v2-color-secondary-500)',
                    600: 'var(--v2-color-secondary-600)',
                    700: 'var(--v2-color-secondary-700)',
                    800: 'var(--v2-color-secondary-800)',
                    900: 'var(--v2-color-secondary-900)'
                },
                success: {
                    100: 'var(--v2-color-success-100)',
                    200: 'var(--v2-color-success-200)',
                    300: 'var(--v2-color-success-300)',
                    400: 'var(--v2-color-success-400)',
                    500: 'var(--v2-color-success-500)',
                    600: 'var(--v2-color-success-600)',
                    700: 'var(--v2-color-success-700)',
                    800: 'var(--v2-color-success-800)',
                    900: 'var(--v2-color-success-900)'
                },
                danger: {
                    100: 'var(--v2-color-danger-100)',
                    200: 'var(--v2-color-danger-200)',
                    300: 'var(--v2-color-danger-300)',
                    400: 'var(--v2-color-danger-400)',
                    500: 'var(--v2-color-danger-500)',
                    600: 'var(--v2-color-danger-600)',
                    700: 'var(--v2-color-danger-700)',
                    800: 'var(--v2-color-danger-800)',
                    900: 'var(--v2-color-danger-900)'
                },
                error: {
                    100: 'var(--v2-color-error-100)',
                    200: 'var(--v2-color-error-200)',
                    300: 'var(--v2-color-error-300)',
                    400: 'var(--v2-color-error-400)',
                    500: 'var(--v2-color-error-500)',
                    600: 'var(--v2-color-error-600)',
                    700: 'var(--v2-color-error-700)',
                    800: 'var(--v2-color-error-800)',
                    900: 'var(--v2-color-error-900)'
                },
                info: {
                    100: 'var(--v2-color-info-100)',
                    200: 'var(--v2-color-info-200)',
                    300: 'var(--v2-color-info-300)',
                    400: 'var(--v2-color-info-400)',
                    500: 'var(--v2-color-info-500)',
                    600: 'var(--v2-color-info-600)',
                    700: 'var(--v2-color-info-700)',
                    800: 'var(--v2-color-info-800)',
                    900: 'var(--v2-color-info-900)'
                },

                brandedPrimary: {
                    100: '#F3F0FF',
                    200: '#E1DBFF',
                    300: '#BAADFB',
                    400: '#8D77F8',
                    500: '#6C51F6',
                    600: '#6951E0',
                    700: '#5842C1',
                    800: '#3923A9',
                    900: '#211075'
                },
                brandedDarkGrey: {
                    100: '#F4F5FB',
                    200: '#E4E5F6',
                    300: '#C9C9DE',
                    400: '#8F92BD',
                    500: '#6A6CAF',
                    600: '#525298',
                    700: '#373781',
                    800: '#212163',
                    900: '#10103C'
                },
                brandedGray: {
                    100: '#F9F9FA',
                    200: '#F4F5F6',
                    300: '#EEEFF2',
                    400: '#E2E4E9',
                    500: '#C9CCD4',
                    600: '#B2B7C2',
                    700: '#A4AAB6',
                    800: '#959CAC',
                    900: '#8B92A2'
                },
                boxShadow: {
                    sm: '0px 4px 8px rgb(0 0 0 / 0.05)',
                    DEFAULT: '0px 12px 24px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
                    md: 'box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);',
                    lg: '0px 24px 128px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
                    '2xl': '0 25px 50px -12px rgb(0 0 0 / 0.25)',
                    inner: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)',
                    none: 'none',
                },
                gray: {
                    300: '#d1d5db',
                    700: '#374151',
                }
            },
            spacing: {
                '70px': '70px',
            },
            templateCards: {
                'cardMinWidth': '280px',
                'cardMaxWidth': '400px'
            },
            transitionDuration: {
                '2000': '2000ms',
                '400': '400ms',
            },
            padding: {
                '1.5': '0.375rem',
                '2.5': '0.625rem',
                '3.5': '0.875rem',
            },
            borderRadius: {
                none: '0px',
                xs: '4px',
                sm: '6px',
                DEFAULT: '8px',
                md: '10px',
                lg: '18px',
                xl: '20px',
                '2xl': '24px',
                '3xl': '28px',
                full: '9999px',
                '[14px]': '0.875rem',
            },
            fontFamily: {
                'inter': ['Inter', 'sans-serif'],
            },
            backgroundColor: {
                gray: {
                    100: '#f3f4f6',
                    200: '#e5e7eb',
                    300: '#d1d5db',
                    400: '#9ca3af',
                    500: '#6b7280',
                    600: '#4b5563',
                    700: '#374151',
                    800: '#1f2937',
                    900: '#111827',
                }
            },
        },
    },
    variants: {
        extend: {},
    },

    plugins: [
        require('@tailwindcss/line-clamp'),
    ],
};
